import demoRoutes from "src/router/routes/demoRoutes"
import managerRouteList from "src/router/routes/manager/routes"
import technicianRouteList from "src/router/routes/technician/routes"
import { Log } from "src/util/classes/log"
import { GlobalNamedPath, NamedManagerPath, NamedPath } from "src/util/enums/namedPaths"
import { NavigationGuardWithThis, RouteRecordRaw } from "vue-router"

const logBadPath: NavigationGuardWithThis<undefined> = (to, from) => {
  Log.warning({ message: "Bad URL", data: { to, from } })
}

export const technicianRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => null,
    children: [
      {
        path: "",
        name: NamedPath.INDEX,
        redirect: { name: NamedPath.INITIATE_APP },
      },
    ],
  },
  {
    path: "/no-browser",
    name: NamedPath.NO_BROWSER,
    component: () => import("src/pages/technician/NoBrowser.vue"),
  },

  ...technicianRouteList,
]

export const managerRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => null,
    children: [
      {
        path: "",
        name: NamedManagerPath.INDEX,
        redirect: { name: NamedManagerPath.INITIATE_APP },
      },
    ],
  },
  ...managerRouteList,
]

const globalPaths: RouteRecordRaw[] = [
  {
    path: "/unsupported-browser",
    name: GlobalNamedPath.UNSUPPORTED_BROWSER,
    component: () => import("src/pages/UnsupportedBrowser.vue"),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    name: GlobalNamedPath.NOT_FOUND,
    component: () => import("src/pages/404NotFound.vue"),
    beforeEnter: logBadPath,
  },
]

if (process.env.DEV || process.env.DEBUGGING) {
  technicianRoutes.unshift(demoRoutes)
  managerRoutes.unshift(demoRoutes)
}

technicianRoutes.push(...globalPaths)
managerRoutes.push(...globalPaths)
